// @flow
import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { Container, Card } from 'statsradio/themes/v3/Stylesheet';
import styled from 'styled-components';
import { type MetricType, type Period } from '../../../domain/DashboardData';
import AudienceComparisonHeader from './AudienceComparisonHeader';
import AudienceComparisonContent from './AudienceComparisonContent';

const AudienceCard = styled(Card)`
  flex-direction: column;
  padding: ${props => props.theme.V3.metrics.margin.large}px;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
`;

interface Props {
  data: Object,
  onMetricChange: (metric: MetricType) => void,
  period: Period,
  t: any,
}

interface State {
  metricType: MetricType
}

class AudienceComparisonCard extends Component<Props, State> {
  state = { metricType: 'reach' };

  onMetricTypeChange = (newMetricType: MetricType) => {
    this.setState({ metricType: newMetricType });
    this.props.onMetricChange(newMetricType);
  };

  render() {
    const { data, period } = this.props;

    return (
      <Container>
        <AudienceCard>
          <Row>
            <AudienceComparisonHeader metricType={this.state.metricType} onChange={this.onMetricTypeChange} />
          </Row>
          <Row>
            <AudienceComparisonContent metricType={this.state.metricType} period={period} data={data} />
          </Row>
        </AudienceCard>
      </Container>
    );
  }

}

export default translate('dashboard')(AudienceComparisonCard);



// WEBPACK FOOTER //
// ./src/statsradio/modules/dashboard/v2/components/audienceComparison/AudienceComparisonCard.js